import { render } from "./my-documents.vue?vue&type=template&id=c60ee59e&scoped=true"
import script from "./my-documents.vue?vue&type=script&lang=js"
export * from "./my-documents.vue?vue&type=script&lang=js"

import "./my-documents.vue?vue&type=style&index=0&id=c60ee59e&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c60ee59e"]])

export default __exports__